import ipaddr from "ipaddr.js";

type Cidr = [ipaddr.IPv4 | ipaddr.IPv6, number];

// Comma-separated CIDRs a self-hosted operator allowlists past the SSRF block
// (env var ALLOWED_CIDR_BLOCKS), matching the pony proxy's deployment allowlist.
// A matched address bypasses every block, including loopback/link-local/
// metadata. Read from process.env on each call so it stays out of the client
// bundle's import-time evaluation; invalid entries are dropped rather than
// widening the allowlist. Only reached from low-frequency admin/config fetch
// paths.
export function allowedCidrBlocks(): Cidr[] {
  return (process.env.ALLOWED_CIDR_BLOCKS ?? "")
    .split(",")
    .map((s) => s.trim())
    .filter((s) => s.length > 0)
    .flatMap((block) => {
      try {
        return [ipaddr.parseCIDR(block)];
      } catch {
        return [];
      }
    });
}
